import { render, staticRenderFns } from "./QuickActions.vue?vue&type=template&id=d49b3738&scoped=true"
import script from "./QuickActions.vue?vue&type=script&lang=ts"
export * from "./QuickActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49b3738",
  null
  
)

export default component.exports